<template>
  <div class="breadcrumb-wrap">
    <ul class="breadcrumb-list">
      <li v-for="(breadcrum, breadcrumIndex) in props.breadcrumbs" :key="breadcrumIndex">
        <div class="breadcrumb-item">
          <NuxtLink v-if="(breadcrum.movable ?? true)" :to="breadcrum.to" :class="{ home: breadcrumIndex === 0 }" @click.prevent="clickBreadCrumbs(breadcrum)">
            {{ breadcrum.label }}
            <span class="dropdown-arrow" v-if="!searchFlag && (breadcrum.child?.length ?? 0) > 0 && breadcrumIndex < props.breadcrumbs.length -1 && !breadcrum.hideChild">
              <img
                src="@/assets/images/pc/icon-hcon/icon-arrow-left-xs-gray100.svg"
                alt="화살표"
              />
            </span>
            <span class="dropdown-arrow" v-else-if="breadcrumIndex !== 0 && searchFlag && (breadcrum.child?.length ?? 0) > 0 && !breadcrum.hideChild">
              <img
                src="@/assets/images/pc/icon-hcon/icon-arrow-left-xs-gray100.svg"
                alt="화살표"
              />
            </span>
          </NuxtLink>
          <template v-else>
            {{ breadcrum.label }}
            <span class="dropdown-arrow" v-if="(breadcrum.child?.length ?? 0) > 0 && breadcrumIndex < props.breadcrumbs.length -1 && !breadcrum.hideChild">
              <img
                src="@/assets/images/pc/icon-hcon/icon-arrow-left-xs-gray100.svg"
                alt="화살표"
              />
            </span>
          </template>
          <ul class="dropdown-menu" v-if="!searchFlag && (breadcrum.child?.length ?? 0) > 0 && breadcrumIndex < props.breadcrumbs.length -1 && !breadcrum.hideChild" :class="{ active: activeDropdownIndex === breadcrumIndex }">
            <li v-for="(items, index) in breadcrum.child" :key="index" :class="{ on: breadcrum.label == items?.label}">
              <NuxtLink v-if="(items.movable ?? true)" :to="items?.to" @click.prevent="clickBreadCrumbs(items)">
                  {{ items?.label }}
              </NuxtLink>
              <template v-else>
                {{ items?.label }}
              </template>
            </li>
          </ul>
          <ul class="dropdown-menu" v-else-if="searchFlag && (breadcrum.child?.length ?? 0) > 0 && !breadcrum.hideChild" :class="{ active: activeDropdownIndex === breadcrumIndex }">
            <li v-for="(items, index) in breadcrum.child" :key="index" :class="{ on: breadcrum.label == items?.label}">
              <NuxtLink v-if="(items.movable ?? true)" :to="items?.to" @click.prevent="clickBreadCrumbs(items)">
                  {{ items?.label }}
              </NuxtLink>
              <template v-else>
                {{ items?.label }}
              </template>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>

interface BreadcrumbItem {
  label : string        // 화면에 보여질 브래드크럼명 ex) 홈 > 마이 Hcon
  to: string            // 브래드크럼명 클릭 시 이동되는 경로(useRoute를 이용하여 자동으로 파일 폴더 경로대로 지정됨) ex) pc/mypage
  child?: any[]         // 하위 자식들 ex) pc/mypage의 경우 해당 경로 하위에 있는 값 들(구매관리, 핀발행 요청 관리, H캐시 관리 등) 
  category?: boolean    // 추후 상품목록에서 카테고리, 브랜드 별로 필터링 시 사용될 값
  hideChild?: boolean   // 하위 자식들 숨김 여부 ex) true => pc/mypage 자식들이 드롭다운으로 안보여짐
  skipParent?: string[] // 중간에 skip할 부모 브래드크럼들 => ex) ['마이 Hcon', '회원 정보 관리'] => 회원탈퇴 완료 페이지에서 해당 부모 브래드크럼을 skip
  movable?: boolean     // 브래드크럼명 클릭 시 이동 여부 => ex) 기획전 목록, 기획전 상세 페이지의 경우 브래드크럼 클릭 시 해당 경로로 이동 x
  id? : string
  depth?: number
  highCategoryId?: string
  categoryId?: string
  brandId? : string
}

const props = defineProps<{
  breadcrumbs: BreadcrumbItem[]
  searchFlag?: boolean
}>()

const emit = defineEmits(['click-breadcrumbs']);

const clickBreadCrumbs = (breadcrumb : BreadcrumbItem) => {
  emit('click-breadcrumbs', breadcrumb)
}

const activeDropdownIndex = ref<number | null>(null);

</script>

<style lang="scss" scoped>
</style>
